import type * as React from 'react'
import { cn } from '../lib/cn'

/** A key cap. `keys="g q"` renders two caps; `mod` renders Ctrl (or ⌘ on macOS). */
export function Kbd({ keys, className, ...props }: React.ComponentProps<'span'> & { keys: string }) {
  const parts = keys.split(' ').filter(Boolean)
  return (
    <span data-slot="kbd" className={cn('inline-flex items-center gap-0.5', className)} {...props}>
      {parts.map((part, i) => (
        <kbd
          // biome-ignore lint/suspicious/noArrayIndexKey: key caps are positional
          key={i}
          className="inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-border-strong bg-card px-1 font-sans text-2xs text-muted-foreground shadow-xs"
        >
          {formatKey(part)}
        </kbd>
      ))}
    </span>
  )
}

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)

export function formatKey(part: string): string {
  return part
    .split('+')
    .map((k) => {
      switch (k.toLowerCase()) {
        case 'mod':
          return isMac ? '⌘' : 'Ctrl'
        case 'shift':
          return '⇧'
        case 'enter':
          return '↵'
        case 'escape':
        case 'esc':
          return 'Esc'
        case 'space':
          return 'Space'
        default:
          return k.length === 1 ? k.toUpperCase() : k
      }
    })
    .join(isMac ? '' : '+')
}
